import BaseApi from './BaseApi';

export type StaffId = {
  bucketName: string;
};

/**
 * スタッフアイコン削除API。
 */
class DeleteStaffImgApi extends BaseApi {
  async delete(params: StaffId) {
    return await this.execute('deleteStaffImgApi', {
      method: 'DELETE',
      body: params
    }).then(({ status }) => status === 1);
  }
}

export default DeleteStaffImgApi;
